// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-component[data-v-9a0984a6] {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 10px;
}
.radio-component:not(.active) .show-when-active[data-v-9a0984a6] {
  visibility: hidden;
}
.radio-component .middle-section[data-v-9a0984a6] {
  height: 90%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.radio-component .middle-section .middle-item[data-v-9a0984a6]:not(:last-child) {
  margin-bottom: auto;
  height: 38px;
  line-height: 1em;
}
.radio-component .middle-section .middle-item[data-v-9a0984a6]:not(:first-child) {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  max-width: 320px;
}
.radio-component .middle-section .status[data-v-9a0984a6] {
  margin: auto;
}
.radio-component .middle-section .ptt[data-v-9a0984a6] {
  margin-top: 0;
}
.notification .height-ident[data-v-9a0984a6] {
  height: 35px;
}
.notification .notification-wrapper[data-v-9a0984a6] {
  position: absolute;
  top: -35px;
  opacity: 0;
  transition: all 0.3s linear;
  left: 3%;
  right: 3%;
  text-align: center;
  background-color: var(--bg-color2);
  border-radius: 5px;
  transition-property: top, opacity;
}
.notification .notification-wrapper.show[data-v-9a0984a6] {
  opacity: 1;
  top: 0;
}
.notification .notification-wrapper span[data-v-9a0984a6] {
  display: block;
  padding: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/radio/RadioComponent.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".radio-component[data-v-9a0984a6] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 0 10px;\n}\n.radio-component:not(.active) .show-when-active[data-v-9a0984a6] {\n  visibility: hidden;\n}\n.radio-component .middle-section[data-v-9a0984a6] {\n  height: 90%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n.radio-component .middle-section .middle-item[data-v-9a0984a6]:not(:last-child) {\n  margin-bottom: auto;\n  height: 38px;\n  line-height: 1em;\n}\n.radio-component .middle-section .middle-item[data-v-9a0984a6]:not(:first-child) {\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  max-width: 320px;\n}\n.radio-component .middle-section .status[data-v-9a0984a6] {\n  margin: auto;\n}\n.radio-component .middle-section .ptt[data-v-9a0984a6] {\n  margin-top: 0;\n}\n.notification .height-ident[data-v-9a0984a6] {\n  height: 35px;\n}\n.notification .notification-wrapper[data-v-9a0984a6] {\n  position: absolute;\n  top: -35px;\n  opacity: 0;\n  transition: all 0.3s linear;\n  left: 3%;\n  right: 3%;\n  text-align: center;\n  background-color: var(--bg-color2);\n  border-radius: 5px;\n  transition-property: top, opacity;\n}\n.notification .notification-wrapper.show[data-v-9a0984a6] {\n  opacity: 1;\n  top: 0;\n}\n.notification .notification-wrapper span[data-v-9a0984a6] {\n  display: block;\n  padding: 5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
